<template>
  <v-card v-if="invoice.emitter != null && invoice.emitter.iva_condition != undefined &&  invoice.emitter.iva_condition.id != emmiterService.CONDITION_IVA_MONO" elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Tributos (Percepciones)</h6>
      <p v-if="!isViewModal" class="text-body-2">Percepciones especiales que se aplican al perfil fiscal</p>
      <v-row>
        <v-col md="12" v-if="!isViewModal && tributos_list.length > 0" class="mb-2">
          <v-btn small :disabled="isDisabledAdd() || (loading_combos && loading_combos['tributos'])" color="blue-grey" class="text-white" @click="addTributeDetail()">
            <v-icon big color="green"> add </v-icon>
            <span>Agregar item</span>
          </v-btn>
        </v-col>
        <v-col md="12">
          <v-data-table 
            :loading="loading_combos['tributos']"
            class="pb-4" 
            :disabled="(invoice.id > 0 && !sale_order) || (loading_combos && loading_combos['tributos'])" 
            :headers="header_tribute" 
            :items="invoice.tributos" 
            style="border: solid 1px #1c1c1c" 
            :hide-default-footer="true" 
            :items-per-page="100"
          >
            <template v-slot:item="props">
              <tr>
                <td>
                  <v-combobox
                    :loading="loading_combos['tributos']"
                    v-model="props.item.impuesto"
                    data-vv-as="impuesto"
                    :name="'impuesto_' + props.index"
                    item-text="name"
                    item-value="id"
                    :items="tributos_list"
                    label="Percepción*"
                    autocomplete="off"
                    v-validate="'required|combobox_required'"
                    :disabled="isViewModal || (invoice.id > 0 && !sale_order)|| (loading_combos && loading_combos['tributos'])"
                    return-object                    
                    @change="onImpuestoChange(props.item)"
                  ></v-combobox>
                  <span class="red--text">{{ errors.first('impuesto_' + props.index) }}</span>
                </td>
                <td style="min-width: 35%">
                  <v-text-field
                    :disabled="isViewModal || (invoice.id > 0 && !sale_order)|| (loading_combos && loading_combos['tributos'])"
                    autocomplete="off"
                    :name="'descripcion_' + props.index"
                    placeholder="Descripción"
                    dense
                    type="text"
                    v-model="props.item.descripcion"
                    class="mt-3"
                  />
                  <span class="red--text">{{ errors.first('descripcion_' + props.index) }}</span>
                </td>

                <td style="width: 100px">
                  <v-text-field
                    :disabled="isViewModal || (invoice.id > 0 && !sale_order)|| (loading_combos && loading_combos['tributos'])"
                    autocomplete="off"
                    :name="'alic_' + props.index"
                    placeholder="Alícuota %*"
                    dense
                    v-validate="'required|decimal'"
                    type="number"
                    v-model="props.item.alic"
                    class="mt-3"
                  />
                  <span class="red--text">{{ errors.first('alic_' + props.index) }}</span>
                </td>
                <td style="width: 120px">
                  <v-text-field
                    :disabled="isViewModal || (invoice.id > 0 && !sale_order)|| (loading_combos && loading_combos['tributos'])"
                    autocomplete="off"
                    :name="'base_imp_' + props.index"
                    placeholder="Base Imponible*"
                    dense
                    v-validate="'required|decimal'"
                    type="number"
                    v-model="props.item.base_imp"
                    class="mt-3"
                  />
                  <span class="red--text">{{ errors.first('base_imp_' + props.index) }}</span>
                </td>
                <td class="text-right" style="width: 100px">{{ formatUtils.formatPrice(calcImporte(props.item)) }}</td>
                <td class="text-center" style="width: 50px">
                  <v-tooltip bottom v-if="!isViewModal">
                    <template v-slot:activator="{ on }">
                      <v-icon :disabled="(invoice.id > 0 && !sale_order) || (loading_combos && loading_combos['tributos'])" v-on="on" small color="red" @click="removeDetail(props.item, 'tributos')"> indeterminate_check_box </v-icon>
                    </template>
                    <span>Remover</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { emmiterService } from "@/libs/ws/emmiterService";
import { impuestosService } from "@/libs/ws/impuestosService";
import { vouchersService } from "@/libs/ws/vouchersService";
import { formatUtils } from "@/libs/utils/formatUtils";
import debounce from "lodash/debounce";
import { mathUtils } from "@/libs/utils/mathUtils";

export default {
  components: {},
  props: {
    invoice: Object,
    loadItemsFromInvoiceCancel: Function,
    loading_combos: Object,
    validator: Object,
    isViewModal: {
      type: Boolean,
      default: false,
    },
    sale_order: {
      type: Boolean,
      default: false,
    },
    imp_total: {
      type: Number,
      default: 0,
    },
    imp_neto: {
      type: Number,
      default: 0,
    },
    imp_tot_conc: {
      type: Number,
      default: 0,
    },
    imp_op_ex: {
      type: Number,
      default: 0,
    },
    imp_iva: {
      type: Number,
      default: 0,
    },
    imp_trib: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    formatUtils: formatUtils,
    emmiterService: emmiterService,
    header_tribute: [
      { text: "Percepción", value: "impuesto.name", sortable: false },
      { text: "Descripción", value: "descripcion", sortable: false },
      { text: "Alícuota %", value: "alic", sortable: false, class: "bg-grey" },
      { text: "Base imponible", value: "base_imp", sortable: false },
      { text: "Importe", value: "importe", sortable: false },
      { text: "", value: "", sortable: false, class: "bg-grey" },
    ],
    tributos_list: [],
    emitter_selected: null,
    receiver_selected: null,
    cbtetipo_selected: null,
    percepcionesRequestId: 0,
  }),
  watch: {
    invoice: {
      handler: function (newValue) {        
        if ((this.emitter_selected == null && newValue.emitter != null) || (newValue.emitter != null && this.emitter_selected.id != newValue.emitter.id)) {
          this.emitter_selected = newValue.emitter;
          this.emitterChangeEvent();
        }
        if ((this.receiver_selected == null && newValue.receiver != null) || (newValue.receiver != null && this.receiver_selected.id != newValue.receiver.id)) {
          this.receiver_selected = newValue.receiver;
          this.debouncedCalcPercepciones();
        }
        if ((this.cbtetipo_selected == null && newValue.cbte_tipo != null) || (newValue.cbte_tipo != null && this.cbtetipo_selected.Id != newValue.cbte_tipo.Id)) {
          this.cbtetipo_selected = newValue.cbte_tipo;
          this.debouncedCalcPercepciones();
        }
      },
      deep: true,
    },
    imp_neto(newValue) {      
      if (newValue > 0) {
        this.debouncedCalcPercepciones();
      }
    },
  },
  created() {
    this.$validator = this.validator;
    // Crear versión debounced del método calcPercepciones
    this.debouncedCalcPercepciones = debounce(() => {
      if(this.isEdit()){
        return;
      }
      this.calcPercepciones();
    }, 500);
  },
  mounted() {
    if (this.invoice.emitter != null) {
      this.emitter_selected = this.invoice.emitter;
      this.emitterChangeEvent();
    }
  },
  methods: {
    isEdit(){
      return this.invoice.id > 0 ;
    },
    isDisabledAdd() {
      return this.invoice.emitter == null || (this.invoice.id > 0 && !this.sale_order) || this.invoice.items_custom.length == 0;
    },
    onImpuestoChange(item) {
      //console.log("onImpuestoChange", item);
      if (item.impuesto && item.impuesto.alicuota_general) {
        item.alic = item.impuesto.alicuota_general;
      }
      this.calcPercepcionEspecifica(this.invoice.tributos.indexOf(item));
    },
    calcImporte(item) {
      if (!item.alic || !item.base_imp) return 0;
      const importe = (parseFloat(item.alic) / 100.0) * parseFloat(item.base_imp);
      // Actualizar el importe en el item
      item.importe = importe;
      return importe.toFixed(2);
    },
    addTributeDetail() {      
      this.invoice.tributos.push({
        descripcion: "",
        alic: 0,
        base_imp: 0,
        importe: 0,
        impuesto: null,
        impuesto_id: null,
        padron_alicuota: null,
        escala_aplicable_desde_monto: null,
        escala_aplicable_hasta_monto: null,
        escala_aplicable_alicuota_excedente: null,
        escala_aplicable_monto_base: null,
      });
    },
    removeDetail(item, colection_name) {
      if (colection_name == "tributos") {
        const index_item = this.invoice.tributos.indexOf(item);
        if (index_item > -1) this.invoice.tributos.splice(index_item, 1);        
      }
    },
    emitterChangeEvent() {
      if (this.invoice.emitter != null && this.invoice.emitter.id) {
        this.getTributos();
      }
    },
    getTributos() {
      const params = { 
        categoria_impuesto: impuestosService.PERCEPCION 
      };
      
      if (this.invoice && this.invoice.emitter && this.invoice.emitter.id) {
        params.emitter = { id: this.invoice.emitter.id };
      }

      if (this.invoice && this.invoice.receiver && this.invoice.receiver.id) {
        params.receiver = { id: this.invoice.receiver.id };
      }

      if (!params.emitter && !params.receiver) {
        //console.log("No se tienen los datos necesarios para consultar las percepciones. Se debe ingresar el emisor.");
        this.tributos_list = [];
        return;
      }

      params.provincia = this.invoice.provincia ? this.invoice.provincia.id : null;

      this.loading_combos["tributos"] = true;

      impuestosService
        .filter(params)
        .then((response) => {
          if (response.status) {
            this.tributos_list = response.result;
            //console.log("percepciones/tributos cargados", this.tributos_list);
          }
        })
        .catch((e) => {
          console.log("impuestosService.filter error", e);
          this.$toast.error(e.msg || "Error al cargar las percepciones");
        })
        .finally(() => {
          this.loading_combos["tributos"] = false;
        });
    },
    getPercepcionCalcParams(){      
      const params = {
        cbte_fch: this.invoice.cbte_fch,      
        emitter: null,
        receiver: null,
        
        imp_total: 0,
        imp_iva: 0,
        imp_neto: 0,
        imp_op_ex: 0,
        imp_tributo: 0,

        detalles: []//id, cbte_tipo, provincia, imp_total, imp_iva, imp_neto, imp_op_ex, imp_tributo
      };
      let provincia_emitter_id = null;
      let provincia_receiver_id = null;
      if (this.invoice && this.invoice.receiver && this.invoice.receiver.id) {
        params.receiver = { id: this.invoice.receiver.id };
        provincia_receiver_id = this.invoice.receiver.provincia ? this.invoice.receiver.provincia.id : null;
      }
      if (this.invoice.emitter && this.invoice.emitter.id) {
        params.emitter = { id: this.invoice.emitter.id };
        provincia_emitter_id = this.invoice.emitter.provincia ? this.invoice.emitter.provincia.id : null;
      }
      
      params.imp_total = this.imp_total;
      params.imp_iva = this.imp_iva;
      params.imp_neto = this.imp_neto;
      params.imp_op_ex = this.imp_op_ex;
      params.imp_tributo = this.imp_trib;

      if(
        params.emitter == null || params.receiver == null ||
        params.emitter == undefined || params.receiver == undefined ||
        !(params.imp_total > 0 || params.imp_iva > 0 || params.imp_neto > 0 || params.imp_op_ex > 0 || params.imp_tributo > 0)
      ){
        //console.log("No se tienen los datos necesarios para consultar las percepciones. Se deben ingresar el receptor, el emisor y los importes de la factura para poder consultar las percepciones correspondientes");
        //console.log("params", params);
        this.tributes = [];
        return null;
      }

      //Agregar detalles por provincia (si los tiene)
      if(this.invoice.items_custom && this.invoice.items_custom.length > 0){
        let detalles_por_provincia = [];
        this.invoice.items_custom.forEach(item => {
          if(!item || !(item.price > 0) || item.product_presentation == null)
            return;

          let provincia_id = null;
          
          //console.log("item.product_presentation.product_provincia", item.product_presentation.product_provincia);
          if(item.product_presentation.product_provincia == null){
            provincia_id = null;//(provincia_receiver_id != null) ? provincia_receiver_id : provincia_emitter_id;//Dijeron que si el producto no tiene provincia no se percibe
          }else{
            provincia_id = item.product_presentation.product_provincia.id;
          }
          
          const totals_item = this.calculateCustomeItemTotals(item);
          detalles_por_provincia.push({
            id: item.id,
            cbte_tipo: this.invoice.cbte_tipo ? this.invoice.cbte_tipo.Id : null,
            provincia: provincia_id,
            imp_total: totals_item.imp_total ? totals_item.imp_total : 0,
            imp_iva: totals_item.imp_iva ? totals_item.imp_iva : 0,
            imp_neto: totals_item.imp_neto ? totals_item.imp_neto : 0,
            imp_op_ex: totals_item.imp_op_ex ? totals_item.imp_op_ex : 0,
            imp_tributo: totals_item.imp_tributo ? totals_item.imp_tributo : 0,
          })
        });
        params.detalles = detalles_por_provincia;
      }

      //console.log("Consultando percepciones con params", params);

      return params;
    },
    calculateCustomeItemTotals(item) {
      let totals = {
        imp_total: 0,
        imp_neto: 0,
        imp_iva: 0,
        imp_op_ex: 0,
        imp_tributo: 0,
      };
      if (item.price == null || item.quantity == null)
        return totals;

      const importe = formatUtils.formatPriceNumber(item.quantity * item.price - item.discount_imp);
      const iva_id = item.iva != null ? item.iva.Id : null;
      if(iva_id == 1 || iva_id == 2){//No Grabado o Excento
        totals.imp_total = importe;
        totals.imp_op_ex = importe;
      }else{
        const iva_id = item.iva != null ? item.iva.Id : null;
        let imp_iva = vouchersService.NoIVAList().includes(iva_id) || iva_id == null ? 0.0 : (formatUtils.formatPriceNumber(importe) * formatUtils.formatPriceNumber(item.iva.Desc.replace("%", ""))) / 100;      
        imp_iva = mathUtils.round(imp_iva, 2);

        totals.imp_total = formatUtils.formatPriceNumber(importe+imp_iva);
        totals.imp_neto = importe;
        totals.imp_iva = formatUtils.formatPriceNumber(imp_iva);
      }

      return totals;
    },
    calcPercepciones() {
      let params = this.getPercepcionCalcParams();
      if(params == null){
        return;
      }      

      if(this.isViewModal){
        return;
      }
      
      // Incrementar el ID de request para invalidar las anteriores
      this.percepcionesRequestId++;
      const currentRequestId = this.percepcionesRequestId;
      
      this.loading_combos['tributos'] = true;
      impuestosService
        .getPercepcionForVoucher(params)
        .then((response) => {
          // Verificar si esta request sigue siendo válida
          if (currentRequestId !== this.percepcionesRequestId) {
            //console.log("Request de percepciones cancelada (obsoleta)");
            return;
          }
          if (response.status) {            

            //Hay que agregar las filas automaticamente y preseleccionar el tributo
            if (response.result.length > 0) {  
              const percepciones = response.result; 
              //Le piso todo: this.invoice.tributos
              this.invoice.tributos= [];
              percepciones.forEach(percepcion => {
                this.invoice.tributos.push({
                  description: percepcion.description,                  
                  importe: percepcion.amount,
                  impuesto: percepcion.impuesto,
                  alic: percepcion.alicuota,
                  base_imp: percepcion.importe_sobre_el_cual_calcular,
                  importe_accumulado: percepcion.importe_accumulado,
                  retenciones_accumuladas: percepcion.retenciones_accumuladas,
                  padron_alicuota: percepcion.padron_alicuota,
                  escala_aplicable_desde_monto: percepcion.escala_aplicable_desde_monto,
                  escala_aplicable_hasta_monto: percepcion.escala_aplicable_hasta_monto,
                  escala_aplicable_alicuota_excedente: percepcion.escala_aplicable_alicuota_excedente,
                  escala_aplicable_monto_base: percepcion.escala_aplicable_monto_base,                  
                });
              });              
            }else{
              this.invoice.tributos = [];
            }
          }
        })
        .catch((e) => {
          // Solo mostrar error si la request sigue siendo válida
          if (currentRequestId !== this.percepcionesRequestId) {
            return;
          }
          console.log("impuestosService.getPercepcionForVoucher error");
          console.log(e);
          this.$toast.error(e.msg);
        })
        .finally(() => {
          // Solo actualizar loading si la request sigue siendo válida
          if (currentRequestId === this.percepcionesRequestId) {
            this.loading_combos['tributos'] = false;
          }
        });
    },
    calcPercepcionEspecifica(item_tributes_index) {
      let params = this.getPercepcionCalcParams();
      if(params == null){
        return;
      }
      //console.log("Consultando percepcion especifica con params", this.invoice.tributos[item_tributes_index]);
      params.impuesto_id = this.invoice.tributos[item_tributes_index].impuesto.id;
      
      this.loading_combos['tributos'] = true;
      impuestosService
        .getPercepcionForVoucher(params)
        .then((response) => {
          if (response.status) {            

            //Hay que agregar las filas automaticamente y preseleccionar el tributo
            if (response.result.length > 0) {  
              const percepcion = response.result[0]; 
              //console.log("before", item_tributes_index);          
                        
              this.$set(this.invoice.tributos, item_tributes_index, {
                description: percepcion.description,                  
                importe: percepcion.amount,
                impuesto: percepcion.impuesto,
                alic: percepcion.alicuota,
                base_imp: percepcion.importe_sobre_el_cual_calcular,
                importe_accumulado: percepcion.importe_accumulado,
                retenciones_accumuladas: percepcion.retenciones_accumuladas,
                padron_alicuota: percepcion.padron_alicuota,
                escala_aplicable_desde_monto: percepcion.escala_aplicable_desde_monto,
                escala_aplicable_hasta_monto: percepcion.escala_aplicable_hasta_monto,
                escala_aplicable_alicuota_excedente: percepcion.escala_aplicable_alicuota_excedente,
                escala_aplicable_monto_base: percepcion.escala_aplicable_monto_base,                  
              });                            

              //console.log("percepcion", percepcion, item_tributes_index);
              
            }
          }
        })
        .catch((e) => {
          console.log("impuestosService.getPercepcionForVoucher error");
          console.log(e);
          this.$toast.error(e.msg);
        })
        .finally(() => (this.loading_combos['tributos'] = false));
    },
  },
};
</script>
